import * as St from './ApplianceCard.styles';
import { calculateDiscount } from './ApplianceCard.utils';

import { ProductType } from '~/core/enums';
import { formatPriceUnitOrFree } from '~/core/utils';
import CardSaleImg from '~atoms/CardSaleImg';
import ItemCountAdjustButton, {
  ItemCountAdjustButtonProps,
} from '~atoms/ItemCountAdjustButton';
import DiscountPriceCell from '~molecules/DiscountPriceCell';

type ContainerProps = React.ComponentProps<typeof St.Container>;

export type ApplianceCardProps = Omit<ContainerProps, 'children'> & {
  description?: string;
  unitOfMeasure?: string;
  priceWithoutDiscount: number;
  priceWithDiscount?: number;
  discountPercentage?: number;
  counterProps?: ItemCountAdjustButtonProps;
  showPriceIfZero?: boolean;
  applianceType?: ProductType;
};

const ApplianceCard = ({
  description,
  priceWithoutDiscount,
  priceWithDiscount,
  discountPercentage = 0,
  counterProps,
  showPriceIfZero = true,
  unitOfMeasure,
  applianceType,
  ...props
}: ApplianceCardProps) => {
  const hasDiscount = discountPercentage > 0;
  const value = formatPriceUnitOrFree(
    priceWithDiscount
      ? priceWithDiscount
      : discountPercentage === 0
        ? priceWithoutDiscount
        : calculateDiscount(discountPercentage, priceWithoutDiscount),
    null,
    true
  );

  return (
    <St.Container {...props}>
      <St.PriceContainer>
        {hasDiscount && <CardSaleImg />}
        <div>
          {(priceWithoutDiscount > 0 || showPriceIfZero) && (
            <St.PriceCell>
              {unitOfMeasure ? `${value} ${unitOfMeasure}` : value}
            </St.PriceCell>
          )}
          {hasDiscount && (
            <DiscountPriceCell
              priceWithoutDiscount={priceWithoutDiscount}
              discountPercentage={discountPercentage}
              applianceType={applianceType}
            />
          )}
        </div>
      </St.PriceContainer>
      {description && <St.Description>{description}</St.Description>}
      {counterProps && <ItemCountAdjustButton {...counterProps} />}
    </St.Container>
  );
};

export default ApplianceCard;
